import {default as BSModal} from 'bootstrap/js/dist/modal';

window.bootstrap.Modal = BSModal;
